function debounceFunc(func, timeout = 300){
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

function throttleFunc(cb, delay) {
  let wait = false;
  let storedArgs = null;

  function checkStoredArgs () {
    if (storedArgs == null) {
      wait = false;
    } else {
      cb(...storedArgs);
      storedArgs = null;
      setTimeout(checkStoredArgs, delay);
    }
  }

  return (...args) => {
    if (wait) {
      storedArgs = args;
      return;
    }

    cb(...args);
    wait = true;
    setTimeout(checkStoredArgs, delay);
  }
}

$(document).ready(() => {
  if ($('.full-feast-slider').length) {
    $('.full-feast-slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false
    });

  }
  if ($('.reviews-slider').length) {
    $('.reviews-slider').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      pauseOnHover: false,
      speed: 1000,
      responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '20px'
        }
      }
    ]
    });
  }

  if ($('.best-seller-slider').length) {
    
    $('.best-seller-slider').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          centerMode: true,
          centerPadding: '30px',
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          centerMode: true,
          centerPadding: '30px',
          dots: true
        }
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '28px',
          dots: true            
        }
      }
    ]
    });
  }

  if ($('.as-good-slider').length) {
    $('.as-good-slider').slick({
      infinite: true,
      slidesToShow: 1,
      speed: 1000,
      cssEase: 'linear',
      autoplay: true,
      fade: true,
      pauseOnHover: false,
      arrows: false,
      dots: true
    });
  }

  if ($('.many-dishes-slider').length) {
    $('.many-dishes-slider').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      centerMode: true,
      centerPadding: '0',
      autoplay: false,
      pauseOnHover: false,
      speed: 1000,
      responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          dots: true
        }
      }
    ]
    });
  }

  if ($('.follow-us-slider').length) {
      $('.follow-us-slider').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: false,
        pauseOnHover: false,
        speed: 1000,
        responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '40px'            
          }
        },
        {
          breakpoint: 365,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '20px'            
          }
        }
      ]
    });
  }

  if ($('.announment-slider-section').length) {

    $('.announment-slider-section').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      pauseOnHover: false,
      speed: 10000,
      autoplaySpeed: 1,
      responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          centerMode: true,
          centerPadding: '20px'
        }
      },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '20px'            
          }
        }
    ]
    });
    
  }
  
})












$(window).scroll(function(){
if ($(this).scrollTop() > 500) {
   $('.pro-detail-fixed-bar').addClass('bar-show');
} else {
   $('.pro-detail-fixed-bar').removeClass('bar-show');
}
});

$(document).ready(function(){

var demo = $(".main-header").width();
$(".main-header .nav-item").mouseover(function(){
$(this).children(".sub-menu").addClass("visible");

$(this).children(".sub-menu").css("width", demo)
});

$(".main-header .nav-item").mouseout(function(){
$(this).children(".sub-menu").removeClass("visible");
});

// <<---------->>

$(".reviews-section .slider-com-arrow-left").click(function(){
$(".reviews-slider .slick-prev").click();
});
$(".reviews-section .slider-com-arrow-right").click(function(){
$(".reviews-slider .slick-next").click();
});


// <<---------->>

$(".best-sellers-section .slider-com-arrow-left").click(function(){
$(".best-sellers-section .slick-prev").click();
});
$(".best-sellers-section .slider-com-arrow-right").click(function(){
$(".best-sellers-section .slick-next").click();
});


// <<---------->>
$(".filter-btn-area .filter-btn").click(function(){
$(".filter-modal").addClass("show");
});
$(".filter-modal .close-btn").click(function(){
$(".filter-modal").removeClass("show");
});


$(".filter-btn-area .filter-btn").click(function(){
$("body").addClass("overflow-hidden");
});
$(".filter-modal .close-btn").click(function(){
$("body").removeClass("overflow-hidden");
});

// <<---------->>

$(".navbar-toggler").click(function(){
$(".main-header .navbar-collapse").toggleClass("open");
$("body").toggleClass("overflow-hidden");
});


$(".filter-btn-area .dropdown .dropdown-item").click(function(){
var filterText = $(this).text();
$(".filter-btn-area .filter-btn-toggle span").text(filterText);
});



});

var windowSize = $(window).width();
if(windowSize <= 767){

// -------

$('.slick-slider').slick('refresh');

// ------

// $('#ingredients').addClass('tab-pane fade');
//$('#method').addClass('tab-pane fade');


}
else{
$('#ingredients').removeClass('tab-pane fade');
// $('#method').removeClass('tab-pane fade');
}

var swiper = new Swiper(".gymkhana-slider", {
  slidesPerView: 4,
  loop: true,
  keyboard: false,
  allowTouchMove: false,
  autoplay: {
    delay: 4000,
  }, 
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 4,
    },
  },
});
var swiper2 = new Swiper(".gymkhana-slider-2", {
  effect: "fade",
  loop: true,
  autoplay: {
    delay: 4000,
  },
  thumbs: {
    swiper: swiper,
  },
});


$('.com-product-slider').slick({
slidesToShow: 4,
arrows: false,
responsive: [
  {
    breakpoint: 991,
    settings: {
      centerMode: true,
      centerPadding: '40px',
      slidesToShow: 3
    }
  },
  {
    breakpoint: 767,
    settings: {
      centerMode: true,
      centerPadding: '40px',
      slidesToShow: 1
    }
  }
]
});


$('.three-slides-slider').slick({
infinite: true,
slidesToShow: 3,
slidesToScroll: 1,
dots: false,
responsive: [
  {
    breakpoint: 1200,
    settings: {
      slidesToShow: 4,
      centerMode: true,
      centerPadding: '0',
      arrows: false
    }
  },
  {
    breakpoint: 767,
    settings: {
      slidesToShow: 2,
      centerMode: true,
      centerPadding: '0',
      arrows: false,
      dots: true
    }
  },
  {
    breakpoint: 600,
    settings: {
      slidesToShow: 2,
      centerMode: true,
      centerPadding: '30px',
      arrows: false,
      dots: true
    }
  },
  {
    breakpoint: 550,
    settings: {
      slidesToShow: 1,
      centerMode: true,
      centerPadding: '28px',
      arrows: false,
      dots: true            
    }
  }
]
});

$('.two-slides-slider').slick({
infinite: true,
slidesToShow: 2,
slidesToScroll: 1,
dots: true,
arrows: false,
autoplay: false,
pauseOnHover: false,
speed: 1000,
responsive: [
  {
    breakpoint: 767,
    settings: {
      centerMode: true,
      centerPadding: '0',
      slidesToShow: 1,
      dots: true
    }
  }
]
});

$('.dish-img-slider').slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    centerMode: true,
    centerPadding: '20px',
    autoplay: true
 });


$('.one-slides-slider').slick({
infinite: true,
slidesToShow: 1,
slidesToScroll: 1,
dots: true,
arrows: false,
autoplay: false,
pauseOnHover: false,
speed: 1000,
centerMode: true,
centerPadding: '0',
});

$('.pro-thumb-slider').slick({
slidesToShow: 1,
slidesToScroll: 1,
arrows: false,
fade: true,
asNavFor: '.pro-thumb-slider-nav',
responsive: [
  {
    breakpoint: 767,
    settings: {
      fade: false,
      dots: true        }
  },
]
});
$('.pro-thumb-slider-nav').slick({
slidesToShow: 5,
slidesToScroll: 1,
asNavFor: '.pro-thumb-slider',
dots: true,
focusOnSelect: true
});


// var swiper = new Swiper(".mySwiper", {
//    pagination: {
//      el: ".swiper-pagination",
//    },
//  });


//outside click hide

$(document).mouseup(function(e) 
{
var container = $(".filter-modal.show");

// if the target of the click isn't the container nor a descendant of the container
if (!container.is(e.target) && container.has(e.target).length === 0) 
{
    //container.hide();
    $(".filter-modal").removeClass("show");
    $("body").removeClass("overflow-hidden");
}
});

$(document).ready(function(){

// onclick checkbox text strike throght
$('.com-check-btn input:checkbox').change(function(){
if($(this).is(":checked")) {
    $(this).parent('.com-check-btn').addClass('label_click');
} else {
     $(this).parent('.com-check-btn').removeClass('label_click');
}
});

// onclick jar radio add class
$(document).on("click", '.attribute input.size', function () {
if ($(this).is(":checked")) {
$('label').removeClass('checked');
$('.var_price').removeClass('checked');
$('.dis-text').removeClass('checked');

$(this).next("label").addClass("checked");
$(this).parent().find(".var_price").addClass("checked");
$(this).parent().find(".dis-text").addClass("checked");

var p_id = $(this).attr('id');
$('.product-form input[name="id"]').val(p_id);
}
});



  // qty
// onclick jar radio add class
$(document).on("click", '.attribute input.qty_option', function () {
if ($(this).is(":checked")) {
  $('label').removeClass('checked');
  $('.var_price').removeClass('checked');
  $('.dis-text').removeClass('checked');

  const clickedEl = $(this)

  clickedEl.attr('id')
  
  $(this).next("label").addClass("checked");
  $(this).parent().find(".var_price").addClass("checked");
  $(this).parent().find(".dis-text").addClass("checked");

}
});
  //qty
  
});


function assignSampleClick() {
  $("input:radio[name=jar_size]").first().click();
  $("input:radio[name=qty_size]").first().click();
  $("input:radio[name=qty_option]").first().click();
}

$(document).ready(function() {
  setTimeout(function() {
    assignSampleClick();
    
    if ($("input:radio[name=qty_option]:checked").length === 0) {
      var firstOption = $("input:radio[name=qty_option]").first();
      firstOption.prop("checked", true);
      firstOption.next("label").addClass("checked");
      firstOption.parent().find(".var_price").addClass("checked");
      firstOption.parent().find(".dis-text").addClass("checked");
    }
    
    $(".form__input-qty").val($("input:radio[name=qty_option]:checked").val() || 1);
  }, 200);
});

$(document).ready(function() {
$('.header__icons').click(function() {
    $('body').addClass('scroll-hide');
});
$('.drawer__close').click(function() {
    $('body').removeClass('scroll-hide');
});
});

$("a.shg-btn.shg-cse.rca-add-to-cart-submit").click(function(e){
  e.preventDefault()
   var cart = document.getElementById("cart-icon-bubble");
  const event = new MouseEvent("click", {
    view: window,
    bubbles: true,
    cancelable: true,
  });

setTimeout(function(){ refreshCartContentV2(); cart.dispatchEvent(event);  },6000);  
  

//  $(cart).trigger('click');
 // cart.addEventListener("click", updateCartContent);

  
  // $("body").addClass("overflow-hidden");
  // $("body").addClass("scroll-hide");
  // $("cart-drawer").addClass("animate");
  // $("cart-drawer").addClass("active");  
});


// End

// single product page

function addproductToCart(variant_id, qty, frequency, unit_type) {
  var qty = $('input.quantity').val();
data = {
  "id": variant_id,
  "quantity": qty
}  
$.ajax({
   type: "POST",
   url: '/cart/add.js',
   data: data,
   dataType: 'json',
   success: function(data) {    
   
     updateCartContent();
   },
error: function (xhr, ajaxOptions, thrownError) {

}      
});  
}
function updateCartContent({ onComplete } = {}) {
 // console.log('updateCartContent');
   refreshCartContentV2(onComplete);
  return false;
  jQuery.getJSON('/cart.js', function(cart) {
    let cartData = cart.items;


    var total_qty= cart.item_count;

       jQuery(".cart-count-bubble span").text(total_qty);
   
      if (cart.items.length) {
  
         if (cart.items.length == 1) {
        
            $("cart-drawer.drawer").removeClass("is-empty");
            $(".drawer__inner-empty").css("display", "none");
        
            $("cart-drawer-items").removeClass("is-empty");
         }
        updateCartHeader(cart)
        onComplete && onComplete(cart)
      }
  });
}

$(document).ready(function() {

  $('section.pro-detail-fixed-bar .com-qty-minus').click(function () {
				var $input = $(this).parent().find('.com-qty-num');
				var count = parseInt($input.text()) - 1;
				count = count < 1 ? 1 : count;
				$input.text(count);
				$input.change();

               $('.quantity').val(count);
				return false;               
              
			});
			$('section.pro-detail-fixed-bar .com-qty-plus').click(function () {
				var $input = $(this).parent().find('.com-qty-num');
				$input.text(parseInt($input.text()) + 1);
				$input.change();

               $('.quantity').val(parseInt($input.text()));
              
				return false;
               
			});
  
  var price = jQuery('input.price').val();
  //console.log(price);

   
  
  $("section.pro-detail-fixed-bar .com-qty-btn").click(function(){
    
    var bundle_prod = jQuery('input.product_type').val();
     // console.log(bundle_prod); 
   var compare_at_price = jQuery('input.compare_at_price').val(); //60
     //console.log(compare_at_price); 
    var regular_price = jQuery('input.regular_price').val(); //46
     // console.log(regular_price); 
    
    //if bundle product
    if(bundle_prod == 'Bundles') 
    {
         var qty = jQuery('.com-qty-num').text();
       //  console.log(qty);
   
         var total_compare = compare_at_price*qty;
     // console.log(total_compare); 
         var total_regular = regular_price*qty;  
    //  console.log(total_regular); 

      var symbol = "£";
       
    var total_compare = symbol.concat(total_compare);
    var total_regular = symbol.concat(total_regular);
      
      //bundle compare price or not
       if(compare_at_price != '') 
        {                 
          jQuery('section.pro-detail-fixed-bar button.com-btn.com-btn-white.subs-btn span.sale_price').text(total_compare); 
          jQuery('section.pro-detail-fixed-bar button.com-btn.com-btn-white.subs-btn span.total_price').text(total_regular);
        }
       else{
         jQuery('section.pro-detail-fixed-bar button.com-btn.com-btn-white.subs-btn span.sale_price').text(' '); 
         jQuery('section.pro-detail-fixed-bar button.com-btn.com-btn-white.subs-btn span.total_price').text(total_regular);      
        }     
    }
    else{
            //not bundle
     var qty = jQuery('.com-qty-num').text();

      
     if(qty < 3)
    {
       $('section.pro-detail-fixed-bar button.com-btn.com-btn-white.subs-btn span.sale_price').text(' ');
       $( 'section.pro-detail-fixed-bar button.com-btn.com-btn-white.subs-btn span.total_price').removeClass( "addstrike" );
       $( 'section.pro-detail-fixed-bar button.com-btn.com-btn-white.subs-btn span.sale_price').removeClass( "active" );
    }
    
    var selling_price='';
    
    if(qty == 3)
    {
      selling_price = price - (price * (5 / 100));
    }
     if( (qty == 4) || (qty == 5) )
     {
      selling_price = price - (price * (10 / 100));
    }
     if(qty >=6 )
     {
      selling_price = price - (price * (15 / 100));
    }

     let symbol = "£";
    
    var total = (price*qty)/100;   
    let total_price = symbol.concat(total);

    if (selling_price != '')
    {
      var selling_price_total =  (selling_price*qty)/100;    
      var selling_price_round = Math.round(selling_price_total);

      let selling_price_total_price = symbol.concat(selling_price_round);

      
      jQuery('section.pro-detail-fixed-bar button.com-btn.com-btn-white.subs-btn span.sale_price').text(selling_price_total_price); 
      jQuery("section.pro-detail-fixed-bar button.com-btn.com-btn-white.subs-btn span.total_price").addClass("addstrike");
       jQuery( 'section.pro-detail-fixed-bar button.com-btn.com-btn-white.subs-btn span.sale_price').addClass( "active" );
    }

  
    jQuery('section.pro-detail-fixed-bar button.com-btn.com-btn-white.subs-btn span.total_price').text(total_price);
    }
    
  });
  
});


$("body").on('mouseenter touchstart mouseleave touchend',".common-product .common-product-img", function () { 
  if($(window).width() > 991) {
    $(this).parent().toggleClass("result_hover");
    
    if($(this).find('video').length > 0) {
      if($(this).find('video')[0].paused){
        $(this).find('video')[0].currentTime = 0;
        $(this).find('video')[0].loop = 1;
        $(this).find('video')[0].play();
      } else {
        $(this).find('video')[0].pause();
      }
    }
  }
 });

$(document).ready(function() {

  $('.drawer__footer input#add-to-cart-button').click(function() {
     $( 'body').addClass( "scroll-hide" );
  });

  var relId = ''; 
  
  $("#navbarSupportedContent .sub-menu a, #navbarSupportedContent a,.header-btn").click(ev => {
     relId = ev.currentTarget.hash
     jQuery(`${relId}`).addClass('is-active')
  })


   $(document).on('scroll',ev => {
     if (relId || location.hash) {
       elementTop = $(relId || location.hash).position().top;
       windowScroll = $(window).scrollTop();
       //console.log(windowScroll + '----' + elementTop);
       if ( windowScroll > (elementTop+100) || windowScroll < (elementTop-50)) {
         //console.log('in if')
         $('section.listing-page.is-active').removeClass('is-active');
       }
     }

  }); 

  
});


// 
$(window).scroll(function() {   
    var scroll = $(window).scrollTop();
    if (scroll >= 100) 
    {
       $("sticky-header.header-wrapper.color-inverse.gradient.header-wrapper--border-bottom").addClass("darkHeader");
       $("sticky-header.header-wrapper.color-inverse.gradient.header-wrapper--border-bottom").removeClass("transparentHeader");
    }
    else
    {
        $("sticky-header.header-wrapper.color-inverse.gradient.header-wrapper--border-bottom").addClass("transparentHeader");
        $("sticky-header.header-wrapper.color-inverse.gradient.header-wrapper--border-bottom").removeClass("darkHeader");
    }
});

// Add & Remove Class on shop hover - desktop
$("ul.navbar-nav.mr-auto li:nth-child(1)").hover(
  function () {
      $("sticky-header.header-wrapper.color-inverse.gradient.header-wrapper--border-bottom").addClass("addbackground");
  },
  function () {
      $("sticky-header.header-wrapper.color-inverse.gradient.header-wrapper--border-bottom").removeClass("addbackground");
  }
);

// Add & Remove class on menu open close
$('summary.header__icon.header__icon--menu.header__icon--summary.link.focus-inset span svg.icon.icon-hamburger').click(function() {
     $("sticky-header.header-wrapper.color-inverse.gradient.header-wrapper--border-bottom").addClass("addbackground");
}); 
$('summary.header__icon.header__icon--menu.header__icon--summary.link.focus-inset span svg.icon.icon-close').click(function() {
     $("sticky-header.header-wrapper.color-inverse.gradient.header-wrapper--border-bottom").removeClass("addbackground");
}); 



$( ".dropdown-menu.sub-menu a" ).hover(
  function() {
    $( this ).addClass( "hover" );
  }, function() {
    $( this ).removeClass( "hover" );
  }
);

function isCalledFromVM() {
  if (typeof global === "object" && !window) {
    return true;
  } else {
    return false;
  }
}

$(document).ready(function(){
  let lastClickedTime = 0
  var toggleClickDelay = 2 * 1000;
  const toggleProAccordian = (event) => {
      
      event.preventDefault()
      event.stopPropagation()
      let $clickedBtn = $(event.currentTarget)
      var accBtnO = $clickedBtn.data('acc');
      $('.acc-body').slideUp();
      if (event.currentTarget.classList.contains('acc-open')) {

        $clickedBtn.addClass('acc-close')
        $clickedBtn.removeClass('acc-open')
        $("#"+accBtnO).slideUp();    
      }
      else {

        //$('.acc-btn.acc-open').removeClass('acc-open').addClass('acc-close')
        $clickedBtn.addClass('acc-open')
        $clickedBtn.removeClass('acc-close')
        $("#"+accBtnO).slideDown();   
      }
  
      $(`.acc-btn:not([data-acc="${accBtnO}"])`).removeClass('acc-open')
      $(`.acc-btn:not([data-acc="${accBtnO}"])`).removeClass('acc-close')
      

    }
  $( '.accordian-item .acc-btn' ).off();
  $('.accordian-item .acc-btn').on('click',  event => {
    toggleProAccordian(event)
  })
 
});

$('.bundle-listdata-section-mobile .accordion-header button').click(event => {
  

  setTimeout(() => {
    let scrollPos = $(event.currentTarget).offset().top
    scrollPos = (scrollPos - 150)
    $([document.documentElement, document.body]).animate({ scrollTop: scrollPos }, 1000)
  }, 400)
});

// video lazy load 
$(window).on('load', function() {
    var lazyVideos = $('video.lazy');
    if ('IntersectionObserver' in window) {
        var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(video) {
                if (video.isIntersecting) {
                    $(video.target).find('source').each(function() {
                        var videoSource = $(this);
                        if (videoSource.is('source')) {
                            videoSource.attr('src', videoSource.data('src'));
                        }
                    });
                    video.target.load();
                    $(video.target).removeClass('lazy');
                    lazyVideoObserver.unobserve(video.target);
                }
            });
        });
        lazyVideos.each(function() {
            lazyVideoObserver.observe(this);
        });
    }
});
 

// Asegurar que al cargar la página se muestre el precio de la primera opción
$(document).ready(function() {
  // Pequeño retraso para asegurar que todos los elementos estén cargados
  setTimeout(function() {
    // Si no hay ninguna opción seleccionada, seleccionar la primera
    if ($("input:radio[name=qty_option]:checked").length === 0) {
      $("input:radio[name=qty_option]").first().prop("checked", true);
    }
    
    // Aplicar las clases necesarias para mostrar el precio
    var firstOption = $("input:radio[name=qty_option]:checked").length ? 
                     $("input:radio[name=qty_option]:checked") : 
                     $("input:radio[name=qty_option]").first();
    
    firstOption.next("label").addClass("checked");
    firstOption.parent().find(".var_price").addClass("checked");
    firstOption.parent().find(".dis-text").addClass("checked");
    
    // Asegurar que el valor de cantidad en el formulario también esté sincronizado
    $(".form__input-qty").val(firstOption.val());
  }, 100);
});
